export enum PagePayoutMethodActionTypes {
  UPDATE_SUCCESS = 'page-payout-method/UPDATE_SUCCESS',
  UPDATE_ERROR = 'page-payout-method/UPDATE_ERROR',
  UPDATE_REQUEST = 'page-payout-method/UPDATE_REQUEST',
}
